export const giftBoxCodes = {
  Box: 'BOX',
  Double: 'DOUBLE',
  Eco: 'ECO',
}
